module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA8CAMAAADsSTwRAAAAdVBMVEUAAADT09PT09PS0tLT09PU1NTS0tLT09PS0tLS0tLS0tLS0tLR0dHS0tLS0tLR0dHS0tLS0tLR0dHR0dHS0tLS0tLS0tLR0dHS0tLS0tLS0tLS0tLR0dHR0dHR0dHR0dHS0tLS0tLS0tLR0dHS0tLS0tLR0dGYDf/jAAAAJnRSTlMAS0xPUVNVV2WBgoOWqaqztbbDxMvMzc/b3Oju7/T19vf4+fv9/hnRXB8AAACvSURBVFjD7dS5EoJAEEXRVhRXxG0QFxQF7v9/oplVTkPEBBb2C29wop4RGR9u91677kciEwIskiwEc5RnCOYhdQimMuYfmXznD0DFvLWeP8xS/AGouABqVVfGGDMgxq39AajoWms27P8mifwBqJgAjaobOz9jjPEZGn+dsb3+4kdRXPwBqFh0VrsbY4z5YtK5PwAVU6BRdQtU8grxwks5hWAymYVgYpHYlXWvlW4qbzNiStQ00hxXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/table_cell2.png
// module id = dWVS
// module chunks = 1